import { Feature } from '@tencent/workbench';
import BaseTitleBarFeature from '@framework/workbench/common/feature/base-titlebar-feature';

@Feature()
export class DevelopmentFeature extends BaseTitleBarFeature {
    public showPerformance() {
        this.getAppServices().editableServiceLayer?.menuManager._actionPerformance();
    }
}
